const phoneNumberFormatter = (phoneNumber) => {
  if (!phoneNumber) return null;
  if (phoneNumber.length === 12) {
    const zero = phoneNumber.slice(0, 3);
    const first = phoneNumber.slice(3, 5);
    const second = phoneNumber.slice(5, 8);
    const third = phoneNumber.slice(8, 10);
    const fourth = phoneNumber.slice(10, 12);
    return `+ ${zero} (${first}) ${second}-${third}-${fourth}`;
  } else {
    return phoneNumber;
  }
};

export default phoneNumberFormatter;
